import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import { t } from 'ember-intl'
import homeUnfilled from '@images/icons/home-unfilled.svg'

export const HomeSidenavLink = <template>
  <SideNavItem data-test-side-nav-home @linkTo="subscription-type.home" @currentWhen="subscription-type.home">
    <SideNavIconComponent @url={{homeUnfilled}} @alt="Sidenav home" />
    <span> {{t "sideNav.home"}}</span>
  </SideNavItem>
</template>

export default HomeSidenavLink
